import {
  ReactFlowProps,
  NodeTypes,
  EdgeTypes,
  SetCenterOptions,
} from "@xyflow/react";
import EmployeeNode from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/EmployeeNode";
import RootNode from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/RootNode";
import AreaNode from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Nodes/AreaNode";
import DefaultEdge from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/CustomReactFlow/Edges/DefaultEdge";

export const nodeTypes: NodeTypes = {
  employeeNode: EmployeeNode,
  areaNode: AreaNode,
  customRootNode: RootNode,
};

export const edgeTypes: EdgeTypes = { customEdge: DefaultEdge };

// Settings for main ReactFlow component
export const reactFlowSettings: ReactFlowProps = {
  nodeTypes,
  edgeTypes,
  minZoom: 0.3,
  defaultEdgeOptions: {
    style: { strokeWidth: 3, stroke: "#C6D4E3", borderRadius: 50, offset: 20 },
  },
  nodesConnectable: false,
  nodesDraggable: false,
  zoomOnScroll: true,
  zoomOnDoubleClick: false,
  panOnDrag: true,
  attributionPosition: "top-left",
  fitView: true,
  fitViewOptions: { maxZoom: 0.7 },
  onlyRenderVisibleElements: true,
};

export const setCenterOptions: SetCenterOptions = {
  zoom: 1,
  duration: 700,
};
